import { connect } from 'react-redux';
import moment from 'moment';
import { getIsArrivalTimeEditable, shouldFetch, getIfArrivalDateIsBeforeLatestArrivalSlotBookingDate } from '../utils';
import {
  getAvailableArrivalTimeSlots,
  setSelectedArrivalTime,
  addArrivalTimeSlotToBooking,
  removeArrivalTimeSlotFromBooking,
  setArrivalPageWasBooked,
} from '../redux/actions/arrivalTime';
import ArrivalTime from '../components/arrivalTime/ArrivalTime';

export const getShouldRedirectToNextPage = (
  { isFetching, wasCalled, wasBooked, errorMessage, selectedArrivalSlotId, arrivalTimeSlots },
  bookingSearch,
  config,
  ignoreStore = false,
  today = moment(),
) => {
  const { siteCode } = bookingSearch;
  if (siteCode === '' || !wasCalled) {
    return false;
  }
  const isArrivalSlotEnabled = config[`REACT_APP_ARRIVAL_SLOT_ENABLED_${siteCode.toUpperCase()}`] === 'true';
  const isBookingFallWithinArrivalSlotWindow = getIfArrivalDateIsBeforeLatestArrivalSlotBookingDate(bookingSearch, config);

  const isArrivalTimeEditable = getIsArrivalTimeEditable(config, bookingSearch, today);
  const isStoreHasBeenCalledWell = !isFetching && wasCalled && !errorMessage;
  const isSelectedArrivalSlotIdExists = isStoreHasBeenCalledWell && wasBooked && selectedArrivalSlotId > 0;
  const isArrivalTimeSlotsEmpty = isStoreHasBeenCalledWell && arrivalTimeSlots.length === 0;

  return !isArrivalSlotEnabled
    || !isBookingFallWithinArrivalSlotWindow
    || (!ignoreStore && isSelectedArrivalSlotIdExists)
    || isArrivalTimeSlotsEmpty
    || !isArrivalTimeEditable
    || (!ignoreStore && !isStoreHasBeenCalledWell);
};

const mapStateToProps = ({ bookingSearch, config, arrivalTime }) => ({
  title: 'Setup your experience',
  subTitle: 'Arrival Time?',
  isArrivalTimeEditable: getIsArrivalTimeEditable(config, bookingSearch),
  arrivalTimeSlots: arrivalTime.arrivalTimeSlots,
  selectedArrivalSlotId: arrivalTime.selectedArrivalSlotId,
  bookedArrivalSlotId: arrivalTime.bookedArrivalSlotId,
  shouldFetchAvailableArrivalTimeSlots: shouldFetch(arrivalTime, bookingSearch, config),
  shouldRedirectToNextPage: getShouldRedirectToNextPage(
    arrivalTime,
    bookingSearch,
    config,
  ),
  refreshTimeInterval: parseInt(config.REACT_APP_REFRESH_TIME_INTERVAL, 10) || 15,
  lastConfigCheckDateTime: config.lastConfigCheckDateTime,
  isShorexEnhancementEnabled: config.REACT_APP_SHOREX_ENHANCEMENT_ENABLED === 'true',
});

const mapDispatchToProps = dispatch => ({
  getAvailableArrivalTimeSlots: isCalledByAnotherAction => dispatch(getAvailableArrivalTimeSlots(isCalledByAnotherAction)),
  setSelectedArrivalTime: selectedArrivalSlotId => dispatch(setSelectedArrivalTime(selectedArrivalSlotId)),
  addArrivalTimeSlotToBooking: () => dispatch(addArrivalTimeSlotToBooking()),
  removeArrivalTimeSlotFromBooking: () => dispatch(removeArrivalTimeSlotFromBooking()),
  setArrivalPageWasBooked: wasBooked => dispatch(setArrivalPageWasBooked(wasBooked)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ArrivalTime);
